import { useApiService } from "medere-ui-framework";
import { SelectablePDFToGenerate } from "../../views/Report/ReportGenerationSelection";

function formatDateForBackend(date: Date) {
  return date.getFullYear() + "-" +
    String(date.getMonth() + 1).padStart(2, "0") + "-" +
    String(date.getDate()).padStart(2, "0") + "T" +
    String(date.getHours()).padStart(2, "0") + ":" +
    String(date.getMinutes()).padStart(2, "0") + ":" +
    String(date.getSeconds()).padStart(2, "0");
}

export function useReportService() {
  const { getMethod, postMethod } = useApiService();
  const baseEndpoint = "/api/secured/reportcontroller";

  function printHospitalizationPDFs(selectablePDFToGenerate: SelectablePDFToGenerate, healthPatientServiceId: number, fromDate: Date, toDate: Date, sessionId: string, includeHoursEvolution: boolean) {
    const bodyToSend = {
      pdfs: {
        HRENTRY: { id: selectablePDFToGenerate.HRENTRY.id, pdfName: selectablePDFToGenerate.HRENTRY.pdfName, toGenerate: selectablePDFToGenerate.HRENTRY.toGenerate },
        EPICRISIS: { id: selectablePDFToGenerate.EPICRISIS.id, pdfName: selectablePDFToGenerate.EPICRISIS.pdfName, toGenerate: selectablePDFToGenerate.EPICRISIS.toGenerate },
        PRESCRIPTION: { id: selectablePDFToGenerate.PRESCRIPTION.id, pdfName: selectablePDFToGenerate.PRESCRIPTION.pdfName, toGenerate: selectablePDFToGenerate.PRESCRIPTION.toGenerate },
        MEDICALEVOLUTION: { id: selectablePDFToGenerate.MEDICALEVOLUTION.id, pdfName: selectablePDFToGenerate.MEDICALEVOLUTION.pdfName, toGenerate: selectablePDFToGenerate.MEDICALEVOLUTION.toGenerate },
        PARAMEDICALEVOLUTION: { id: selectablePDFToGenerate.PARAMEDICALEVOLUTION.id, pdfName: selectablePDFToGenerate.PARAMEDICALEVOLUTION.pdfName, toGenerate: selectablePDFToGenerate.PARAMEDICALEVOLUTION.toGenerate },
        SURGERY: { id: selectablePDFToGenerate.SURGERY.id, pdfName: selectablePDFToGenerate.SURGERY.pdfName, toGenerate: selectablePDFToGenerate.SURGERY.toGenerate },
        VITALSIGN: { id: selectablePDFToGenerate.VITALSIGN.id, pdfName: selectablePDFToGenerate.VITALSIGN.pdfName, toGenerate: selectablePDFToGenerate.VITALSIGN.toGenerate },
        BIRTH: { id: selectablePDFToGenerate.BIRTH.id, pdfName: selectablePDFToGenerate.BIRTH.pdfName, toGenerate: selectablePDFToGenerate.BIRTH.toGenerate },
        HOSPITALIZATIONLEVEL: { id: selectablePDFToGenerate.HOSPITALIZATIONLEVEL.id, pdfName: selectablePDFToGenerate.HOSPITALIZATIONLEVEL.pdfName, toGenerate: selectablePDFToGenerate.HOSPITALIZATIONLEVEL.toGenerate },
        ATTACHEDDOCUMENTATION: { id: selectablePDFToGenerate.ATTACHEDDOCUMENTATION.id, pdfName: selectablePDFToGenerate.ATTACHEDDOCUMENTATION.pdfName, toGenerate: selectablePDFToGenerate.ATTACHEDDOCUMENTATION.toGenerate },
        LABORATORY: { id: selectablePDFToGenerate.LABORATORY.id, pdfName: selectablePDFToGenerate.LABORATORY.pdfName, toGenerate: selectablePDFToGenerate.LABORATORY.toGenerate },
        ADMINISTRATIVE: { id: selectablePDFToGenerate.ADMINISTRATIVE.id, pdfName: selectablePDFToGenerate.ADMINISTRATIVE.pdfName, toGenerate: selectablePDFToGenerate.ADMINISTRATIVE.toGenerate },
        MEDICATIONVALUATION: { id: selectablePDFToGenerate.MEDICATIONVALUATION.id, pdfName: selectablePDFToGenerate.MEDICATIONVALUATION.pdfName, toGenerate: selectablePDFToGenerate.MEDICATIONVALUATION.toGenerate },
        RECIPE: { id: selectablePDFToGenerate.RECIPE.id, pdfName: selectablePDFToGenerate.RECIPE.pdfName, toGenerate: selectablePDFToGenerate.RECIPE.toGenerate },
        NURSINGEVOLUTION: { id: selectablePDFToGenerate.NURSINGEVOLUTION.id, pdfName: selectablePDFToGenerate.NURSINGEVOLUTION.pdfName, toGenerate: selectablePDFToGenerate.NURSINGEVOLUTION.toGenerate },
      },
    includeHoursEvolution: includeHoursEvolution,
    };
    console.log("Fecha desde, ", fromDate);
    console.log("Fecha hasta, ", toDate);
    return postMethod<number>({
      basePath: baseEndpoint,
      endpoint: "/printHospitalizationPDFs",
      body: bodyToSend,
      params: {
        healthPatientServiceId: healthPatientServiceId,
        initialDateTime: formatDateForBackend(fromDate),
        finalDateTime: formatDateForBackend(toDate),
        sessionId: sessionId,
      }
    }).catch(error => {
      console.error("Error al imprimir el reporte:", error);
      throw error;
    });
  }

  function getCurrentStatus(genId: number): Promise<string> {
    return getMethod<string>({
      basePath: baseEndpoint,
      endpoint: "/pdfGenerationStatus",
      params: { genId }
    }).catch(error => {
      console.error(error);
      throw error;
    });
  }

  function hasMedicalValuationPermission(): Promise<boolean> {
    return getMethod<boolean>({
      basePath: baseEndpoint,
      endpoint: "/hasMedicalValuationPermission",
      params: {}
    }).catch(error => {
      console.error(error);
      throw error;
    });
  }

  function closeWindow(sessionId: string) {
    return postMethod({
      basePath: baseEndpoint,
      endpoint: "/closeWindow",
      body: null,
      params: { sessionId }
    }).catch(error => {
      console.error("Error al imprimir el reporte:", error);
      throw error;
    });
  }

  return {
    printHospitalizationPDFs,
    getCurrentStatus,
    hasMedicalValuationPermission,
    closeWindow,
  };
}
